module.exports = __webpack_public_path__ + "img/image01.abd1d9f4.jpg";